module.exports = "p-header {\r\n    font-size: larger;\r\n}"